import React from 'react'
import { Form, Input } from 'antd'

const SaveFilter = ({ form, fieldKey }) => {
	const { getFieldDecorator } = form
	return (
		<Form.Item label="NAME">
			{getFieldDecorator(fieldKey, {
				validateTrigger: ['onChange', 'onBlur'],
				rules: [
					{
						required: true,
						whitespace: true,
						message: 'Filter Name is Required.'
					}
				]
			})(<Input placeholder="Name" />)}
		</Form.Item>
	)
}

export default SaveFilter
